import { Component, input } from '@angular/core';
import { LucideIconComponent } from '../../../lucide-icon/lucide-icon.component';

@Component({
  selector: 'app-address-display',
  standalone: true,
  imports: [LucideIconComponent],
  templateUrl: './address-display.component.html',
  styleUrls: ['./address-display.component.css'],
})
export class AddressDisplayComponent {
  line1 = input<string>();
  line2 = input<string>();
  placeholder = input<string>('Enter address');
}
